<template>
  <div class="header">
    <div class="header__content">
      <nav class="navbar navbar-inverse bg-inverse navbar-expand-lg">
        <div class="container-fluid">
          <a class="navbar-brand navbar-brand--secondary" href="#">
            <router-link to="/">
              <img
                src="../assets/images/logo.png"
                alt
                width="350"
                height="39"
              />
            </router-link>
          </a>
          <p class="version-app">V032024003</p>
          <div class="navbar__aside">
            <nav class="nav-access d-none d-lg-block">
              <ul>
                <li>
                  <a @click="navigate()">My List </a>
                </li>

                <li>
                  <router-link to="/content/landing"
                    >My Organization</router-link
                  >
                </li>
              </ul>
            </nav>
            <!-- /.nav -->

            <a @click="goTocart()" class="btn-cart d-lg-block"
              ><i class="ico-cart"></i
            ></a>

            <md-menu md-size="auto" md-align-trigger>
              <md-button md-menu-trigger class="btn-user">
                <!-- <i class="ico-user"></i> -->
                <i class="fas fa-user-circle"></i>

                <span>{{ username }}</span>

                <!-- <i class="ico-arrow-down"></i> -->
                <i class="fas fa-caret-down"></i>
              </md-button>

              <md-menu-content>
                <md-menu-item @click="$router.push('/content/profile')"
                  >Profile</md-menu-item
                >
                <md-menu-item @click="$router.push('/content/transactions')"
                  >Transactions</md-menu-item
                >
                <md-menu-item @click="logOut()">Log Out</md-menu-item>
                <!-- <md-menu-item @click="logOutForce()">Log Out Force</md-menu-item> -->
              </md-menu-content>
            </md-menu>
          </div>
          <!-- /.navbar__aside -->
        </div>
        <!-- /.container-fluid -->
      </nav>
    </div>
    <!-- /.header__content -->

    <div class="header__bar">
      <div class="container-fluid"></div>
      <!-- <p>Organizations Name</p> -->
      <!-- /.container-fluid -->
    </div>
    <!-- /.header__bar -->
    <nav class="nav-access d-block d-lg-none">
      <ul>
        <li>
          <a @click="navigate()" style="color: grey !important">
            My Mishloach Manot
          </a>
        </li>

        <li>
          <router-link to="/content/landing" style="color: grey !important"
            >My Organization</router-link
          >
        </li>
      </ul>
    </nav>
    <!-- /.nav -->
  </div>
  <!-- /.header -->
</template>
<script>
import AuthService from "../authService.js";

export default {
  name: "HeaderPage",
  data: function() {
    return {
      auth: new AuthService(),
    };
  },
  computed: {
    settings() {
      return this.$store.state.settings;
    },
    username() {
      //console.log(this.$store.state.userProfile)
      let user = this.$store.state.userProfile;
      // console.log("userrrrrr ",user)
      //  let str = user[0].memberFirstName.charAt(0).toUpperCase()+". "+ user[0].memberLastName
      return null;
    },
    promotions() {
      let data = this.$store.state.promotions;
      let prop = "sortOrder";
      data = data.sort(function(a, b) {
        return a[prop] > b[prop] ? 1 : b[prop] > a[prop] ? -1 : 0;
      });
      return data;
    },
    filteredData() {
      return this.$store.state.list;
    },
    lastYear() {
      return this.$store.state.lastYear;
    },
  },
  methods: {
    checkIfMembersSelected: function(data) {
      let val = false;
      for (let i = 0; i < data.length; i++) {
        if (data[i].selected && !data[i].paid) {
          val = true;
          return val;
        }
      }
      return val;
    },
    checkIfNotPaid: function(data) {
      // console.log("this",this.$store.state.list)
      let val = false;
      //console.log('data  ',data)
      for (let i = 0; i < data.length; i++) {
        if (data[i].paid) {
          val = true;
          return val;
        }
      }
      return val;
    },
    logOut: function() {
      //console.log( this.auth)
      localStorage.clear();
      sessionStorage.clear();
      this.auth.signOut();
    },
    logOutForce() {
      this.auth.logMeout("testttttt");
    },
    savePromotions: function(promo, save) {
      let parsedpromo = JSON.parse(JSON.stringify(promo));
      // console.log("parsedpromo", parsedpromo, save);
      let combo = [];
      //   lets uncheck people first
      let false_promos = [];
      for (let i = 0; i < parsedpromo.length; i++) {
        if (!parsedpromo[i].value && parsedpromo[i].allCategories.length) {
          for (let z = 0; z < parsedpromo[i].allCategories.length; z++) {
            for (let k = 0; k < this.filteredData.length; k++) {
              //  if promotions categories have more than all category, loop through member categries and check if exsist, if yes select
              if (
                !this.filteredData[k].paid &&
                this.filteredData[k].mCategories.indexOf(
                  Number(parsedpromo[i].allCategories[z])
                ) !== -1
              ) {
                // this.filteredData[k].selected = false;
              }
            }
          }
        }
      }

      //  if checked and  select based on categories
      for (let i = 0; i < parsedpromo.length; i++) {
        //  object to push to api
        let promo_obj = {
          promo: {},
          ids: [],
          members: [],
        };
        let obj = {
          itemId: parsedpromo[i].itemId,
          price: parsedpromo[i].price,
          quantity: 1,
          description: parsedpromo[i].displayText,
          shipTo: "",
          message: "",
        };

        if (parsedpromo[i].allCategories.length && parsedpromo[i].value) {
          promo_obj.promo = parsedpromo[i];
          for (let z = 0; z < parsedpromo[i].allCategories.length; z++) {
            if (
              parsedpromo[i].allCategories[z].toLowerCase() === "all" &&
              parsedpromo[i].value
            ) {
              //  if all category is select , select all pplz
              for (let d = 0; d < this.filteredData.length; d++) {
                if (!this.filteredData[d].paid) {
                  this.filteredData[d].selected = true;
                  if (promo_obj.ids.indexOf(this.filteredData[d].id) === -1) {
                    promo_obj.ids.push(this.filteredData[d].id);
                    promo_obj.members.push(this.filteredData[d]);
                  }
                }
              }
              combo.push(promo_obj);
            } else {
              for (let k = 0; k < this.filteredData.length; k++) {
                //  if promotions categories have more than all category, loop through member categries and check if exsist, if yes select
                if (
                  !this.filteredData[k].paid &&
                  this.filteredData[k].mCategories.indexOf(
                    Number(parsedpromo[i].allCategories[z])
                  ) !== -1
                ) {
                  this.filteredData[k].selected = true;
                  if (promo_obj.ids.indexOf(this.filteredData[k].id) === -1) {
                    promo_obj.ids.push(this.filteredData[k].id);
                    promo_obj.members.push(this.filteredData[k]);
                  }
                }
              }
              combo.push(promo_obj);
            }
          }
        }
      }
      this.$store.commit("updateListInPromotions", combo);
      return true;
      ////console.log("promo combo ", combo);
    },
    checkIfPromoSelected(data) {
      //  check if at least one of the promotions selected
      let check = false;
      for (let i = 0; i < data.length; i++) {
        if (data[i].value === true && !data[i].paid) {
          check = true;
          return check;
        }
      }
      return check;
    },
    goTocart() {
      let addOptions = this.$store.getters.addOptions;

      if (this.$store.state.userProfile[0].confirmed === 0) {
        this.$store.commit("showToast", {
          message: "Please Confirm Your Profile",
          position: "bottom",
          type: "error",
        });
        this.$router.push({
          name: "profile",
        });
      } else {
        console.log("LIST CHANGED ", this.$store.state.listChanged);
        let promocheck = this.checkIfPromoSelected(this.promotions); // check if at least one promo selected
        if (!this.$store.state.listChanged) {
          if (promocheck) {
            let finish = this.savePromotions(this.promotions); // lets make sure whole list is selected and combined by promotions if needed and function is finished
            if (finish) {
              if (addOptions) {
                this.$router.push("/content/promo").catch((error) => {
                  if (error.name != "NavigationDuplicated") {
                    throw error;
                  }
                });
              } else {
                this.$router.push("/content/payment").catch((error) => {
                  if (error.name != "NavigationDuplicated") {
                    throw error;
                  }
                });
              }
            }
          } else {
            if (addOptions) {
              this.$router.push("/content/promo").catch((error) => {
                if (error.name != "NavigationDuplicated") {
                  throw error;
                }
              });
            } else {
              this.$router.push("/content/payment").catch((error) => {
                if (error.name != "NavigationDuplicated") {
                  throw error;
                }
              });
            }
          }
        } else {
          // trigger only user made changes to the selected list and didnt save it
          this.$store.commit("showToast", {
            message: "Please Save Your Changes Before Proceeding",
            position: "bottom",
            type: "error",
          });
        }
      }
    },
    navigate: function() {
      // make sure profile is confirmed
      if (this.$store.state.userProfile[0].confirmed === 0) {
        this.$store.commit("showToast", {
          message: "Please Confirm Your Profile",
          position: "bottom",
          type: "error",
        });

        this.$router.push({
          name: "profile",
        });
      } else {
        // if not not last year orders screen and no promo screen, go straigt to list selections
        if (
          !this.settings[0].displayLastYearsOrderIntro &&
          !this.settings[0].displayPromotionsScreen
        ) {
          this.$router.push("/content/list").catch((error) => {
            if (error.name != "NavigationDuplicated") {
              throw error;
            }
          });
        } else if (
          this.settings[0].displayLastYearsOrderIntro &&
          this.lastYear.length
        ) {
          let sel = this.checkIfMembersSelected(this.$store.state.list);
          let paid = this.checkIfNotPaid(this.$store.state.list);
          //console.log("sel ",sel, "paid ",paid)

          //  check if there is smth in the cart already (members) if no, go to oreder history if yes to promo page if is enabled
          if (!sel && !paid && this.settings[0].displayLastYearsOrders) {
            this.$router.push("/content/orderhistory").catch((error) => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          } else {
            if (!this.settings[0].displayPromotionsScreen) {
              this.$router.push("/content/list").catch((error) => {
                if (error.name != "NavigationDuplicated") {
                  throw error;
                }
              });
            } else {
              //  this is custom details promotion as a screen,
              this.$router.push("/content/promotionscreen").catch((error) => {
                if (error.name != "NavigationDuplicated") {
                  throw error;
                }
              });
            }
          }
        } else if (
          !this.settings[0].displayLastYearsOrderIntro ||
          !this.lastYear.length
        ) {
          if (!this.settings[0].displayPromotionsScreen) {
            this.$router.push("/content/list").catch((error) => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          } else {
            this.$router.push("/content/promotionscreen").catch((error) => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
            //  this is custom details promotion as a screen,
          }
        }
      }
    },
  },
};
</script>
<style scoped>
.version-app {
  position: absolute;
  top: 59px;
  left: 59px;
  color: #dedede;
  font-weight: 800;
  font-size: 10px;
}

.btn-user span {
  color: #70777c;
  padding: 0 21px 0 8px;
  text-transform: lowercase;
}
.link {
  color: grey !important;
}
.fa-user-circle {
  font-size: 26px;
  color: #ff607f;
  width: 26px;
  height: 26px;
  display: inline-block;
  vertical-align: middle;
}
.ico-cart {
  /* background-image: url(data:image/png;base64,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); */
  background-position: 76.416667% 28.57142857142857%;
  background-size: 100% 100%;
  width: 27px;
  height: 26px;
  display: inline-block;
  vertical-align: middle;
  font-size: 0;
  background-image: url("../assets/images/sprite.png");
}
.fa-caret-down {
  width: 11px;
  width: 11px;
  height: 17px;
  display: inline-block;
  vertical-align: middle;
  font-size: 18px;
  color: #b1b1b1;
}
.md-menu-content {
  z-index: 100;
}
</style>
